<template>
    <div class="layout-sub-ymd-title">
       <div class="layout-sub-ymd-title-box dsp-flex">
            <div class="ymd-title-box-left"></div>
            <div class="ymd-title-box" v-bind:class="{'direct-rtl': parseInt(settingConfigData.nianyueRishi) == 1}">
                <span class="title-span"><span v-for="string in stringArr">{{string}}</span></span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RecordYmdTitle',
    computed: {
        settingConfigData() {
            return this.$store.state.setting.settingConfigData;
        },
    },
    data() {
        return {
            stringArr: ['年', '月', '日', '时'],
        }
    }
}
</script>